import { useEffect, useState } from "react";
import aboutImg from "../assats/gallary8.webp"
import { Swiper, SwiperSlide } from 'swiper/react';
import First from "../assats/1.webp";
import Second from "../assats/2.webp";
import Third from "../assats/3.webp";
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import { Autoplay, EffectFade, FreeMode, Navigation, Pagination } from 'swiper/modules';
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import slider1 from "../assats/slider1.png";
import slider2 from "../assats/slider2.png";
import slider3 from "../assats/slider3.png";
import aboutImg2 from "../assats/about2.webp";
import aboutImg3 from "../assats/office.jpg";
import BlurFram from "../assats/blurFram.png";
import ArrowPrevIcon from "../assats/prevIcon.png";
import ArrowNextIcon from "../assats/nextIcon.png";
import gallaryImg1 from "../assats/gallaryImg/g1.jpg"
import gallaryImg2 from "../assats/gallaryImg/g2.jpg"
import gallaryImg3 from "../assats/gallaryImg/g3.jpg"
import gallaryImg4 from "../assats/gallaryImg/g4.jpg"
import gallaryImg5 from "../assats/gallaryImg/g5.jpg"
import gallaryImg6 from "../assats/gallaryImg/g6.jpg"
import gallaryImg7 from "../assats/gallaryImg/g7.jpg"
import gallaryImg8 from "../assats/gallaryImg/g8.jpg"
import gallaryImg9 from "../assats/gallaryImg/g9.jpg"
import gallaryImg10 from "../assats/gallaryImg/g10.jpg"
import gallaryImg11 from "../assats/gallaryImg/g11.jpg"
import gallaryImg12 from "../assats/gallaryImg/g12.jpg"
import gallaryImg13 from "../assats/gallaryImg/g13.jpg"
import gallaryImg14 from "../assats/gallaryImg/g14.jpg"
import gallaryImg15 from "../assats/gallaryImg/g15.jpg"
import gallaryImg16 from "../assats/gallaryImg/g16.jpg"
import gallaryImg17 from "../assats/gallaryImg/g17.jpg"
import gallaryImg18 from "../assats/gallaryImg/g18.jpg"
import gallaryImg19 from "../assats/gallaryImg/g19.jpg"
import gallaryImg20 from "../assats/gallaryImg/g20.jpg"
import gallaryImg21 from "../assats/gallaryImg/g21.jpg"
import gallaryImg22 from "../assats/gallaryImg/video1.mp4"
import gallaryImg23 from "../assats/gallaryImg/video2.mp4"
import gallaryImg24 from "../assats/gallaryImg/video3.mp4"
import gallaryImg25 from "../assats/gallaryImg/g22.jpg"
import gallaryImg26 from "../assats/gallaryImg/g23.jpg"
import gallaryImg27 from "../assats/gallaryImg/g24.jpg"
import gallaryImg28 from "../assats/gallaryImg/g25.jpg"
import gallaryImg29 from "../assats/gallaryImg/g26.jpg"
import gallaryImg30 from "../assats/gallaryImg/g27.jpg"
import gallaryImg31 from "../assats/gallaryImg/g28.jpg"
import gallaryImg32 from "../assats/gallaryImg/g29.jpg"
import gallaryImg33 from "../assats/gallaryImg/g30.jpg"
import gallaryImg34 from "../assats/gallaryImg/g31.jpg"
import gallaryImg35 from "../assats/gallaryImg/g32.jpg"
import gallaryImg36 from "../assats/gallaryImg/g33.jpg"
import gallaryImg37 from "../assats/gallaryImg/g34.jpg"
import gallaryImg38 from "../assats/gallaryImg/g35.jpg"
import gallaryImg39 from "../assats/gallaryImg/g36.jpg"
import gallaryImg40 from "../assats/gallaryImg/video4.mp4"
import gallaryImg41 from "../assats/gallaryImg/video5.mp4"
import gallaryImg42 from "../assats/gallaryImg/video6.mp4"
import gallaryImg43 from "../assats/gallaryImg/video7.mp4"
import gallaryImg44 from "../assats/gallaryImg/video8.mp4"
import gallaryImg45 from "../assats/gallaryImg/video9.mp4"

const Home = () => {
    const navigate = useNavigate();

    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [loadData, setLoadData] = useState(false);

    const GallaryData = [
        { id: 1, image: gallaryImg1, title: 'Moulding the living spaces', isVideo: false },
        { id: 2, image: gallaryImg2, title: 'Moulding the living spaces', isVideo: false },
        { id: 3, image: gallaryImg3, title: 'test', isVideo: false },
        { id: 4, image: gallaryImg4, title: 'test', isVideo: false },
        { id: 5, image: gallaryImg5, title: 'test', isVideo: false },
        { id: 6, image: gallaryImg6, title: 'Moulding the living spaces', isVideo: false },
        { id: 7, image: gallaryImg7, title: 'Moulding the living spaces', isVideo: false },
        { id: 8, image: gallaryImg8, title: 'Moulding the living spaces', isVideo: false },
        { id: 9, image: gallaryImg9, title: 'test', isVideo: false },
        { id: 10, image: gallaryImg10, title: 'Moulding the living spaces', isVideo: false },
        { id: 11, image: gallaryImg11, title: 'test', isVideo: false },
        { id: 12, image: gallaryImg12, title: 'test', isVideo: false },
        { id: 13, image: gallaryImg13, title: 'Moulding the living spaces', isVideo: false },
        { id: 14, image: gallaryImg14, title: 'Moulding the living spaces', isVideo: false },
        { id: 15, image: gallaryImg15, title: 'test', isVideo: false },
        { id: 16, image: gallaryImg16, title: 'Moulding the living spaces', isVideo: false },
        { id: 17, image: gallaryImg17, title: 'test', isVideo: false },
        { id: 18, image: gallaryImg18, title: 'test', isVideo: false },
        { id: 19, image: gallaryImg19, title: 'test', isVideo: false },
        { id: 20, image: gallaryImg20, title: 'test', isVideo: false },
        { id: 21, image: gallaryImg21, title: 'test', isVideo: false },
        { id: 22, image: gallaryImg22, title: 'test', isVideo: true },
        { id: 23, image: gallaryImg23, title: 'test', isVideo: true },
        { id: 24, image: gallaryImg24, title: 'test', isVideo: true },
        { id: 25, image: gallaryImg25, title: 'test', isVideo: false },
        { id: 26, image: gallaryImg26, title: 'test', isVideo: false },
        { id: 27, image: gallaryImg27, title: 'test', isVideo: false },
        { id: 28, image: gallaryImg28, title: 'test', isVideo: false },
        { id: 29, image: gallaryImg29, title: 'test', isVideo: false },
        { id: 30, image: gallaryImg30, title: 'test', isVideo: false },
        { id: 31, image: gallaryImg31, title: 'test', isVideo: false },
        { id: 32, image: gallaryImg32, title: 'test', isVideo: false },
        { id: 33, image: gallaryImg33, title: 'test', isVideo: false },
        { id: 34, image: gallaryImg34, title: 'test', isVideo: false },
        { id: 35, image: gallaryImg35, title: 'test', isVideo: false },
        { id: 36, image: gallaryImg36, title: 'test', isVideo: false },
        { id: 37, image: gallaryImg37, title: 'test', isVideo: false },
        { id: 38, image: gallaryImg38, title: 'test', isVideo: false },
        { id: 39, image: gallaryImg39, title: 'test', isVideo: false },
        { id: 40, image: gallaryImg40, title: 'test', isVideo: true },
        { id: 41, image: gallaryImg41, title: 'test', isVideo: true },
        { id: 42, image: gallaryImg42, title: 'test', isVideo: true },
        { id: 43, image: gallaryImg43, title: 'test', isVideo: true },
        { id: 44, image: gallaryImg44, title: 'test', isVideo: true },
        { id: 45, image: gallaryImg45, title: 'test', isVideo: true },
    ]
    useEffect(() => {
        document.getElementById('main-title').classList.add('zoom-out');
        document.getElementById('heading').classList.add('Heading');
    }, []);
    const offerSliderBreakpoints = {
        320: {
            slidesPerView: 1,
            spaceBetween: 16,
        },
        580: {
            slidesPerView: 2,
            spaceBetween: 16,
        },
        1153: {
            slidesPerView: 3,
            spaceBetween: 16,
        },
        1920: {
            slidesPerView: 5,
            spaceBetween: 24,
        },
    };

    return (
        <>
            {/* <div className="bg">
                <p className="text-center text-[72px] text-black py-80" id="main-title">asasdas</p>
            </div> */}
            <div className="">
                <Swiper
                    spaceBetween={30}
                    centeredSlides={true}
                    autoplay={{
                        delay: 6000,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    navigation={true}
                    modules={[Autoplay, Pagination, Navigation]}
                    className="mySwiper"
                >
                    <SwiperSlide>
                        {/* <div className="bg">
                            <div className="innerImg py-20" >
                                <p className="text-[72px]">Welocme to Designcore Studio</p>
                                <button className="inline-flex items-center bg-[#A35733] py-2 px-6 text-black hover:text-white border border-[#A35733]" onClick={() => navigate("/contact")}>
                                    Contact Us
                                </button>
                            </div>
                        </div> */}
                        <div className="bg">
                            <p className="text-center text-[72px] italic text-[#000] py-80" id="heading">Welocme to Designcore Studio</p>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        {/* <div>
                            <img src={slider2} className="w-full h-[800px]" />
                        </div> */}
                        <div className="bg1">
                            <p className="text-center text-[1px] text-[#A35733] py-80">.</p>
                        </div>

                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="bg2">
                            <p className="text-center text-[1px] text-[#A35733] py-80">.</p>
                        </div>
                    </SwiperSlide>
                </Swiper>
            </div>
            <div className="container md:mx-auto">
                <section class="py-20 section-padding" id="section_2">
                    <div class="container">
                        <div class="grid grid-cols-1 lg:grid-cols-2">
                            <div className="px-10" >
                                <p className="text-xl border-b-4 border-[#A35733] pb-3 font-light text-[#A35733]">About Us</p>
                                <h2 class="mt-4 mb-4 text-[28px] text-slate-700 font-medium"><span class="text-muted">DesignCore</span> Studio</h2>
                                <h4 class=" mb-3 text-[24px] text-slate-700	font-medium">Since 1991, we have grown into a family of creative and innovative designers who are committed to excellence and unparalleled design</h4>
                                <p>We believe creative designs are the result of meaningful dialogue and trust between the designer and client. In every project, we strive to fully understand our clients’ needs and apply their feedback and ideas into our designs. We do, however, use our expertise to ensure that the end result is as professional as possible.</p>
                            </div>

                            <div className="flex flex-col lg:flex-row lg:space-x-20" id="main-title">
                                <div class="col-lg-3 col-md-5 col-5 mx-lg-auto pt-20">
                                    <img src={aboutImg3} class="rounded-full w-64 h-64 m-auto" alt="" />
                                </div>
                                <div class="col-lg-4 col-md-7 col-7 pt-10 lg:pt-0">
                                    <img src={aboutImg2} class="rounded-full w-96 h-96 m-auto" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div className="container md:mx-auto">
                <section class="py-20 section-padding" id="section_2">
                    <div class="container">
                        <div class="">
                            <div className="px-10" >
                                <p className="text-xl border-b-4 border-[#A35733] pb-3 font-light text-[#A35733]">Our Services</p>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 p-10 gap-5" >
                                <div class="max-w-sm bg-white rounded-lg shadow-lg shadow-gray-500 ">
                                    <a href="#">
                                        <img class="rounded-t-lg" src={First} alt="" />
                                    </a>
                                    <div class="p-5">
                                        <h5 class="mb-2 text-2xl font-bold text-black">SPATIAL PLANNING</h5>
                                        <p class="mb-3 font-normal text-gray-400  ">All Great Things Have Humble Beginnings</p>
                                        <p class="mb-3 font-normal text-gray-400 ">Our Spatial Planning services suit each client’s specific needs, requirements and taste. Our architects do everything to reflect our client’s desires and translate those into a design that hits all the right notes. Contact us today to see what we are able to do to transform your space and Management.</p>
                                        <button className="rounded-full inline-flex items-center bg-[#915213] hover:bg-[#b68b60] border-0 py-2 px-6 text-white" onClick={() => navigate("/contact")}>
                                            Contact Us
                                        </button>
                                    </div>
                                </div>
                                <div class="max-w-sm bg-white rounded-lg shadow-lg shadow-gray-500 ">
                                    <a href="#">
                                        <img class="rounded-t-lg" src={Second} alt="" />
                                    </a>
                                    <div class="p-5">
                                        <h5 class="mb-2 text-2xl font-bold text-black">EXECUTION</h5>
                                        <p class="mb-3 font-normal text-gray-400  ">The Way to Your Dream Space Starts Here</p>
                                        <p class="mb-3 font-normal text-gray-400 ">Sometimes the little things make all the difference. Our team is equipped to handle all site and execution related concerns. Whatever your interior design needs may be, our team of engineers and designers are here to make sure they are executed to perfection. Contact us today and get started.</p>
                                        <button className="rounded-full inline-flex items-center bg-[#915213] hover:bg-[#b68b60] border-0 py-2 px-6 text-white" onClick={() => navigate("/contact")}>
                                            Contact Us
                                        </button>
                                    </div>
                                </div>
                                <div class="max-w-sm bg-white rounded-lg shadow-lg shadow-gray-500	 ">
                                    <a href="#">
                                        <img class="rounded-t-lg" src={Third} alt="" />
                                    </a>
                                    <div class="p-5">
                                        <h5 class="mb-2 text-2xl font-bold text-black">STYLING</h5>
                                        <p class="mb-3 font-normal text-gray-400  ">The Little Touches that Make All the Difference</p>
                                        <p class="mb-3 font-normal text-gray-400 ">From furnishings and material selection to interior architectural planning, we imbue each space with the owner’s unique style and personality. Brighten up your space with our styling that meets the needs of each area. Get in touch with us today to start benefiting from our outstanding services.</p>
                                        <button className="rounded-full inline-flex items-center bg-[#915213] hover:bg-[#b68b60] border-0 py-2 px-6 text-white" onClick={() => navigate("/contact")}>
                                            Contact Us
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div className="container md:mx-auto">
                <div className="px-10" >
                    <p className="text-xl border-b-4 border-[#A35733] pb-3 font-light text-[#A35733]">Gallary</p>
                </div>
                <div className="p-10 ">
                    {/* {GallaryData.map((item, index) => {
                        return (
                            <div
                                key={index}
                                // className="image-container  transform transition duration-200 hover:scale-75 hover:opacity-200"
                                className="image-container"
                            // onMouseEnter={() => setHoveredIndex(index)}
                            // onMouseLeave={() => setHoveredIndex(null)}
                            >
                                {item.isVideo ?
                                    <video controls autoplay className="h-96 w-96 rounded-lg">
                                        <source src={item.image} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>  
                                    :   
                                    <a href="https://www.instagram.com/p/C6-6BmMB9Mc/?img_index=1"><img src={item.image} alt="" className="image h-96 w-96 rounded-lg " /></a>
                                }   
                            </div>   
                        )
                    })} */}

                    <Swiper
                        // id="handPicked_products"
                        breakpoints={offerSliderBreakpoints}
                        modules={[Navigation]}
                        spaceBetween={30}
                        navigation={{
                            nextEl: '.next',
                            prevEl: '.prev',
                        }}>
                        {GallaryData.map((item) => (
                            <SwiperSlide>
                                <div
                                    className="image-container">
                                    {item.isVideo ?
                                        <a href="https://www.instagram.com/designcore_studio/?img_index=1"><video controls autoplay className="h-96 w-96 rounded-lg">
                                            <source src={item.image} type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video></a>
                                        :
                                        <a href="https://www.instagram.com/designcore_studio/?img_index=1"><img src={item.image} alt="" className="image h-96 w-96 rounded-lg " /></a>
                                    }
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <div className="flex justify-end space-x-5 mt-5">
                        <div className="prev">
                            <img src={ArrowPrevIcon} className="w-10 h-10 cursor-pointer" />
                        </div >
                        <div className="next" >
                            <img src={ArrowNextIcon} className="w-10 h-10 cursor-pointer" />
                        </div>
                    </div>

                </div>
                {/* <div className="flex justify-center">
                    <button className="inline-flex items-center hover:bg-[#A35733] py-2 px-6 text-black hover:text-white border border-[#A35733]" onClick={() => setLoadData(true)}>
                        Load More
                    </button>
                </div> */}
            </div >
        </>
    )
}
export default Home;